// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l892","questions":"styles_questions__2mEa9","footer":"styles_footer__194Qk"};